import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EstimateSelector from './EstimateSelector';
import addEstimateToSelection from '../../../actions/share/addEstimateToSelection';
import removeEstimateFromSelection from '../../../actions/share/removeEstimateFromSelection';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const { entities, share } = estimateBuilder;
  const theEstimate = entities.estimates.byId[ownProps.designId];
  const isSelected = share.selection.indexOf(ownProps.designId) !== -1;
  const isDisabled = share.selection.length > 3 && !isSelected;
  return {
    estimateName: theEstimate.name,
    isSelected,
    isShared: theEstimate.sharedEmail !== null,
    isDisabled,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { addDesign: addEstimateToSelection, removeEstimate: removeEstimateFromSelection },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(EstimateSelector);
